



























import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import CancelButton from '@/components/CancelButton.vue';
import Dialog from '@/components/Dialog.vue';
import ConfirmButton from '@/components/ConfirmButton.vue';
import {Action, Getter} from 'vuex-class';
import {Device, Subscription} from '@/types';
import AccountService from '@/services/account.service';
import EventBus from '@/services/eventbus.service';

@Component({
  components: {ConfirmButton, Dialog, CancelButton},
})
export default class TransferSubscriptions extends Vue {
  @Action private addOrganisationsAsync!: any;
  @Getter private activeOrganisationId!: number;
  @Getter private organisations!: any;
  @Getter private activeAccountId!: number;
  @Getter private activeAccount!: any;
  @Getter private hasPermission: any;
  @Prop() private selectedSubscriptions: any;
  @Prop() private showTransferDialog: any;
  private destinationOrganisationId: number | null = null;
  private loading = false;
  private error: string | undefined = '';

  @Watch('showTransferDialog')
  private async onAccountChange() {
    this.loading = true;
    try {
      this.addOrganisationsAsync();
    } finally {
      this.loading = false;
    }
  }

  @Watch('destinationOrganisationId')
  private async onDestinationChange() {
    if (!this.destinationOrganisationId) {
      return;
    }
    const subscriptionsByOrganisation = new Map();
    for (const sub of this.selectedSubscriptions) {
      const org = sub.organisation_id;

      if (!subscriptionsByOrganisation.has(org)) {
        subscriptionsByOrganisation.set(org, []);
      }
      subscriptionsByOrganisation.get(org).push(sub);
    }
    for (const [organisationId, orgSubscriptions] of subscriptionsByOrganisation.entries()) {
      const subscriptionIdsForThisOrg = orgSubscriptions.map(
          (s: {subscription_id: string}) => s.subscription_id,
      );
      try {
        const canTransfer = await AccountService.canTransferSubscriptionsCheck(
            this.activeAccountId,
            {
              sourceOrganisationId: organisationId,
              destinationOrganisationId: this.destinationOrganisationId,
              subscriptionIds: subscriptionIdsForThisOrg,
            },
        );
        this.error = !canTransfer.result ? canTransfer.reason : '';
      } catch (error) {
        this.error = `Error checking transfer for organisation ${organisationId}. ${error}`;
      }
    }
  }

  private async transferSubscriptions() {
    const subscriptionIds = this.selectedSubscriptions.map(
        (s: {subscription_id: string}) => s.subscription_id,
    );
    try {
      if (!this.destinationOrganisationId) {
        return;
      }
      if (this.selectedSubscriptions.length === 1) {
        await AccountService.transferDetachedSubscription(this.activeAccountId, {
          sourceOrganisationId: this.selectedSubscriptions[0].organisation_id,
          destinationOrganisationId: this.destinationOrganisationId,
          subscriptionIds,
        });
        this.$emit('submit');
      } else {
        const {job_id} = await AccountService.transferDetachedSubscriptionsBulk(this.activeAccountId, {
          destinationOrganisationId: this.destinationOrganisationId,
          subscriptionIds,
        });
        EventBus.$emit('accountJobCreated', job_id);
      }
    } finally {
      this.destinationOrganisationId = null;
      this.$emit('close');
    }
  }

  private get sortedOrganisations() {
    const sortByName = (a: { id: number, name: string }, b: { id: number, name: string }) => {
      return a.name.localeCompare(b.name);
    };
    return this.activeAccount[0].organisations.slice().sort(sortByName);
  }

  private get errors() {
    return this.error;
  }
}
